import { forwardRef } from "react";
import { InstallationSchema } from "types/installation";
import OrderPDF from "../../pages/orders/orderModal/OrderPDF";
import { getUpdatedIsTwoSiteBlocking } from "utils/global/installationHelper";

type Props = {
  data: InstallationSchema[];
  title: string;
};

const MultiOrderPDF = forwardRef<HTMLDivElement, Props>(function MultiOrderPDF(
  { data },
  ref,
) {
  return (
    <div style={{ display: "none" }}>
      <div ref={ref}>
        {data.map((installation) => {
          const twoSided = getUpdatedIsTwoSiteBlocking(installation);
          const copies = twoSided ? 4 : 2;

          return Array.from({ length: copies }).map((_, i) => (
            <OrderPDF
              key={`${installation.id}-${i}`}
              dateRangeFrom={installation.updatedDateRangeFrom}
              dateRangeTo={installation.updatedDateRangeTo}
              timeFrom={
                installation.additionalInformation?.additionalTimeFrom ??
                installation.timeFrom
              }
              timeTill={
                installation.additionalInformation?.additionalTimeTill ??
                installation.timeTill
              }
              fileName={`${installation.payment.paymentId || ""}`}
              installation={installation}
              skipOuterWrapper={true}
            />
          ));
        })}
      </div>
    </div>
  );
});

export default MultiOrderPDF;
